"use client";

import { useQuery } from "@tanstack/react-query";

import { getErrorLogsByTaskId } from "@/src/requests/error-log";

export const ERROR_LOG_CACHE_KEY = "error-log";

export function useErrorLogs(taskId: string | null, options?: { enabled?: boolean }) {
  const query = useQuery({
    queryKey: [ERROR_LOG_CACHE_KEY, taskId],
    queryFn: () => {
      if (!taskId) {
        return [];
      }

      return getErrorLogsByTaskId(taskId);
    },
    enabled: (options?.enabled !== false && !!taskId) ?? false,
  });

  return {
    errorLogs: query.data ?? [],
    isFetching: query.isFetching,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
